/**
 * Rates are displayed according to the dominant currency in the pair
 * The dominant currency is determined based on the order returned by the API
 * The currency order array is located in /settings?keys[]=currency under the name "symbols"
 */

export const orderPairByDominance = (
  currency1: string,
  currency2: string,
  currencies: string[],
): [string, string] | undefined => {
  if (!currencies) {
    return undefined
  }

  const currency1Position = currencies.indexOf(currency1)
  const currency2Position = currencies.indexOf(currency2)
  const marketBaseCurrency =
    currency1Position < currency2Position ? currency1 : currency1Position > currency2Position ? currency2 : ''
  const marketCounterCurrency =
    currency1Position < currency2Position ? currency2 : currency1Position > currency2Position ? currency1 : ''

  return [marketBaseCurrency, marketCounterCurrency]
}

export const base = (currency1: string, currency2: string, currencies: string[]): string | undefined => {
  const ordered = orderPairByDominance(currency1, currency2, currencies)
  return ordered && ordered[0]
}

export const counter = (currency1: string, currency2: string, currencies: string[]): string | undefined => {
  const ordered = orderPairByDominance(currency1, currency2, currencies)
  return ordered && ordered[1]
}
